import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  useEffect(() => {
    // Add background animation effect
    document.body.classList.add('futuristic-bg');
    
    return () => {
      document.body.classList.remove('futuristic-bg');
    };
  }, []);

  return (
    <div className="layout-wrapper">
      <div className="bg-animation">
        <div className="bg-gradient"></div>
        <div className="bg-pattern"></div>
      </div>
      <Navbar />
      <Container className="py-4 min-vh-80 content-container">
        {children}
      </Container>
      <Footer />
    </div>
  );
};

export default Layout;
